var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.modalOpen === true
    ? _c("div", { staticClass: "favourites-share-modal" }, [
        _c("div", { staticClass: "favourites-share-modal__inner" }, [
          _c("div", { staticClass: "close", on: { click: _vm.closeModal } }, [
            _c("span", { staticClass: "screen-reader-text" }, [
              _vm._v("close")
            ]),
            _vm._v(" "),
            _c("svg", { attrs: { xmlns: "http://www.w3.org/2000/svg" } }, [
              _c("line", {
                attrs: {
                  stroke: "#fff",
                  "stroke-width": "1",
                  x1: "0",
                  x2: "100%",
                  y1: "0",
                  y2: "100%"
                }
              }),
              _vm._v(" "),
              _c("line", {
                attrs: {
                  stroke: "#fff",
                  "stroke-width": "1",
                  x1: "100%",
                  x2: "0",
                  y1: "0",
                  y2: "100%"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("h3", [_vm._v("Share your favourites")]),
          _vm._v(" "),
          _c("div", { staticClass: "share-input" }, [
            _c("input", {
              attrs: { type: "text" },
              domProps: { value: _vm.fullShareUrl }
            }),
            _c("button", {
              staticClass: "btn",
              domProps: { textContent: _vm._s(_vm.copyText) },
              on: { click: _vm.copyShareUrl }
            })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-loader/lib?{}!./scripts/vue/FavouritesShare.vue?vue&type=template&id=66dc0791&
// module id = 170
// module chunks = 6